import { InjectionToken, StaticProvider } from '@angular/core';

import { BaseApiConfig } from '../models/base-api-config.model';

/**
 * Provides API configuration for all marketplace-related endpoints.
 *
 * The `MarketplaceApiConfig` is injected via `MARKETPLACE_API_CONFIG`
 */

export type MarketplaceApiConfig = BaseApiConfig<{
  getOptIn: string;
  updateOptIn: string;
}>;

export const MARKETPLACE_API_CONFIG = new InjectionToken<MarketplaceApiConfig>('MARKETPLACE_API_CONFIG');

export const provideMarketplaceApiConfig = (config: MarketplaceApiConfig): StaticProvider => ({
  provide: MARKETPLACE_API_CONFIG,
  useValue: config,
});
